export default {
  FILTER_SURVEY_LIST: 'FilterSurveyList',
  SORT_SURVEY_LIST: 'SortSurveyList',
  LOAD_SURVEY_LIST_START: 'LoadSurveyListStart',
  LOAD_SURVEY_LIST_END: 'LoadSurveyListEnd',
  TOGGLE_SURVEY_LIST_CONFIRM_DIALOG: 'ToggleSurveyListConfirmDialog',
  SEARCH_SURVEY_LIST_FILTER_STUDY_PROGRAM_START: 'SearchSurveyListFilterStudyProgramStart',
  SEARCH_SURVEY_LIST_FILTER_STUDY_PROGRAM_END: 'SearchSurveyListFilterStudyProgramEnd'
};